import {Injectable} from "@angular/core";

import { of } from "rxjs";
import { FilterFormService } from "../filter_form/filter_form.service";
import { AuthService } from "../../auth.service";
import { DataProvider2 } from "../../provider/data2.provider";


@Injectable()
export class CacheDateService {
	constructor(
		public filter: FilterFormService,
		public authService: AuthService,
		public dp: DataProvider2,
	) {}
	
	
	/**
	 * Получить актуальную дату последнего успешного перестроения кеша
	 * @returns {any}
	 */
	get(): any {
		if ( ! this.authService.isAuth) {
			return of();
		}
		
		const { source } = this.filter.filterParams;
		
		return this.dp.get('/get_cache_status', { source });
	}
}
